var MaintenanceModeConfig = /** @class */ (function () {
    function MaintenanceModeConfig() {
    }
    MaintenanceModeConfig.prototype.isActive = function () {
        var now = new Date();
        return this.enabled && this.startDate.getTime() < now.getTime() && this.endDate.getTime() > now.getTime();
    };
    MaintenanceModeConfig.prototype.isPlanned = function () {
        var now = new Date();
        return this.enabled && now.getTime() < this.startDate.getTime();
    };
    return MaintenanceModeConfig;
}());
export { MaintenanceModeConfig };
